/**
 * component/company/index
 */

import React from 'react';
import Grid from 'material-ui/Grid';
import Helmet from "component/Helmet";
import PAGE_CONFIG from 'config/company.json';
import APP_CONFIG from 'config/app.json';
import { initGA } from 'component/GA'; 

class Works extends React.Component{

  componentDidMount(){
    initGA();
  }

  render(){
    return (
      
      <div className="center-container">
        <Helmet title={PAGE_CONFIG.title} description={PAGE_CONFIG.description} canonical={PAGE_CONFIG.canonical} />
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <div className="contents-title-cont">
                <h1 className="contents-title">{PAGE_CONFIG.title}</h1>
                <p className="contents-sub-title">{PAGE_CONFIG.sub_title}</p>
              </div>
              <div className="company-container cf">
                <div className="middle-container">
                  <div className="middle-inner">
                    <table className="company-table">
                      <tbody>
                      <tr>
                        <th className="t-th">会社名</th>
                        <td className="t-td">{PAGE_CONFIG.name}</td>
                      </tr>
                      <tr>
                        <th className="t-th">創業</th>
                        <td className="t-td">{PAGE_CONFIG.founded}</td>
                      </tr>
                      <tr>
                        <th className="t-th">設立</th>
                        <td className="t-td">{PAGE_CONFIG.established}</td>
                      </tr>
                      <tr>
                        <th className="t-th">代表者</th>
                        <td className="t-td">{PAGE_CONFIG.representative}</td>
                      </tr>
                      <tr>
                        <th className="t-th">役員</th>
                        <td className="t-td">
                          {
                            PAGE_CONFIG.executive.map((key,index) => {
                              return(
                                <p key={index}>{key}</p>
                              )
                            })
                          }
                        </td>
                      </tr>
                      <tr>
                        <th className="t-th">資本金</th>
                        <td className="t-td">{PAGE_CONFIG.capital}</td>
                      </tr>
                      <tr>
                        <th className="t-th">主な事業内容</th>
                        <td className="t-td"><div dangerouslySetInnerHTML={{__html:PAGE_CONFIG.business_summary}}></div></td>
                      </tr>
                      <tr>
                        <th className="t-th">所在地</th>
                        <td className="t-td">
                          {
                            APP_CONFIG.company_list.map((value,index) => {
                              return(
                                <div key={`company_${index}`} className="company-table-list">
                                  <h2>【{value.name}】</h2>
                                  〒{value.zip_code}<br />{value.address}<br />
                                  TEL.{value.tel}<br />
                                  FAX.{value.fax}
                                </div>
                              );
                            })
                          }
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
    )
  }
}

export default Works;


// WEBPACK FOOTER //
// ./src/component/company/index.js